import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';

class NetworkPointSpecificConditionSettingComponentCtrl
    implements ng.IController
{
    public networkPoint: NetworkPointDto;
    public setting: SpecificConditionType;
    public selection: boolean;
    public selectionDescriptionLabel: string;
    public specificConditions: SpecificConditionDto;

    constructor(
        private NetworkPoint: NetworkPointResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {
        if (angular.isUndefined(this.selectionDescriptionLabel)) {
            this.selectionDescriptionLabel = this.setting.toString();
        }
        this.loadSpecificConditions();
    }

    private loadSpecificConditions() {
        this.NetworkPoint.getSpecificConditions(
            { id: this.networkPoint.id0 },
            (result: SpecificConditionDto) => {
                this.specificConditions = result;
            }
        );
    }

    public saveSetting(
        setting: SpecificConditionType,
        selection: boolean,
        oldValue: boolean
    ) {
        this.NetworkPoint.saveSpecificConditions(
            {
                id: this.networkPoint.id0
            },
            { active: selection, type: setting },
            (res: SpecificConditionDto) => {
                this.setting = res.type;
                this.selection = res.active;
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.selection = oldValue;
                this.errorHandler(err);
            }
        );
    }
}

angular.module('app').component('pkpNetworkPointSpecificConditionSetting', {
    controller: NetworkPointSpecificConditionSettingComponentCtrl,
    template:
        require('app/network-point-specific-condition-setting/network-point-specific-condition-setting.component.html'),
    bindings: {
        networkPoint: '=',
        selection: '=',
        setting: '=',
        selectionDescriptionLabel: '<'
    }
});
